export default __webpack_public_path__ + "static/media/success.e69e29ff.svg";